import { quillListsToSemanticHtml } from './quillSemanticLists.js';

/**
 * Quill saves extra line breaks as empty paragraphs (often `<p><br></p>`), which creates
 * large vertical gaps between real paragraphs. Strips those only; `<p>` with text unchanged.
 */
export function collapseQuillBlankParagraphs(html) {
  if (!html || typeof html !== 'string') return html;
  return html.replace(
    /(?:<p(?:\s[^>]*)?>(?:\s|<br\s*\/?>|&nbsp;|\u00a0)*<\/p>[\s\n]*)+/gi,
    ''
  );
}

function stripEmptyDivs(html) {
  let out = html;
  let prev;
  do {
    prev = out;
    out = out.replace(/<div\b[^>]*>(?:\s|<br\s*\/?>|&nbsp;|\u00a0)*<\/div>/gi, '');
  } while (out !== prev);
  return out;
}

function tableVisibleText(tableHtml) {
  return tableHtml
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Remove spacer tables Quill sometimes leaves between real tables. */
function stripEmptyTables(html) {
  return html.replace(/<table\b[^>]*>[\s\S]*?<\/table>/gi, (tableHtml) => (
    tableVisibleText(tableHtml) ? tableHtml : ''
  ));
}

/**
 * Normalize CMS HTML spacing: drop Quill blank lines, empty wrappers, and empty tables.
 */
export function normalizeRichHtmlSpacing(html) {
  if (!html || typeof html !== 'string') return html;
  let out = quillListsToSemanticHtml(html);
  let prev;
  do {
    prev = out;
    out = stripEmptyTables(out);
    out = stripEmptyDivs(out);
    out = collapseQuillBlankParagraphs(out);
  } while (out !== prev);
  out = out.replace(/(<br\s*\/?>\s*){3,}/gi, '<br>');
  // Replace non-breaking spaces with normal breakable spaces so prose wraps properly
  out = out.replace(/&nbsp;/gi, ' ').replace(/\u00a0/g, ' ');
  return out.trim();
}
